import "./third-party/jquery.appear";

const ATTR_NAME = "data-appear-class";
const START_CLASS = "appear-init";

function init() {
  const $win = $(window);
  const scrollLeft = $win.scrollLeft();
  const scrollTop = $win.scrollTop();
  const winWidth = $win.width();
  const winHeight = $win.height();

  const $els = $(`[${ATTR_NAME}]`).filter(function() {
    const $el = $(this);
    const { left, top } = $el.offset();
    const width = $el.width();
    const height = $el.height();
    const invisible = left + width < scrollLeft || left > scrollLeft + winWidth
                   || top + height < scrollTop || top > scrollTop + winHeight;

    if(invisible) {
      $el.removeClass($el.attr(ATTR_NAME));
      return true;
    } else {
      $el.removeClass(START_CLASS).removeAttr(ATTR_NAME)
      return false;
    }
  });

  $els.addClass(START_CLASS).appear(function() {
    const $el = $(this);
    $el.addClass($el.attr(ATTR_NAME)).removeClass(START_CLASS).removeAttr(ATTR_NAME);
  });
}

$(init);
if (window.AJAX) AJAX.onUpdate(init);
